import { useEffect, useState } from 'react';
import { Inputbox } from '@zeeve-platform/inputbox-component';
import { Dropdown } from '@zeeve-platform/dropdown-component';
import axios from 'axios';
import Footer from '../../../components/NextAndPrev';
import {
    getCloudCredList as getCredIdData,
    getInstanceTypes as getInstanceTypesData,
    getCloudRegionData,
} from '../../../services/cloud';
import { CloudConfigDataZoneTypes, ListFormattedType } from '../declaration';
import { getCloudById } from '../../../utils/helpers';

interface Props {
    first: boolean;
    prev: () => void;
    nextPage: () => void;
    setCloudConfigDataZone: (obj: CloudConfigDataZoneTypes) => void;
    cloudConfigDataZone: CloudConfigDataZoneTypes;
    submit: () => void;
    last: boolean;
    isDisable: boolean;
    nodeNames: string[];
    nodeCount: number;
    cloudId: string;
    managedHosting: boolean;
}
interface RegionBody {
    id: string | number;
    region: string;
    region_name: string;
}
interface Cred {
    id: number | string;
    name: string;
    icon: any;
    projects: { name: string; id: string }[];
}

const CloudConfiguration = ({
    first,
    prev,
    nextPage,
    setCloudConfigDataZone,
    cloudConfigDataZone,
    last,
    submit,
    isDisable,
    nodeNames,
    nodeCount,
    managedHosting,
    cloudId,
}: Props) => {
    const [regions, setRegion] = useState([] as RegionBody[]);
    const [credList, setCredList] = useState([] as Cred[]);
    const [instancelist, setInstanceList] = useState([] as { name: string }[]);
    const [gcpProjectList, setGcpProjectList] = useState([] as { name: string; id: string }[]);

    const [instanceType, setInstanceType] = useState(new Array<string>(nodeCount));
    const [showNext, setshowNext] = useState({
        s1: false,
        s2: false,
        s3: false,
    });
    const cid: string = cloudId;
    const loadRegions = async (id: number | string) => {
        try {
            const response: any = await getCloudRegionData(id);

            // const response: any = await (
                // await axios.get(`http://localhost:3001/cloud/regions/asdasdasdas`)
            // ).data;

            if (response && response.success) {
                setRegion(response.data);
            } else {
                setRegion([]);
            }
        } catch (error) {
            setRegion([]);
        }
    };

    const instanceTypeListModify = (arr: { name: string }[]) => {
        const data: ListFormattedType[] = [];
        if (arr.length) {
            arr.forEach((item: any) => {
                data.push({
                    label: item.name,
                    value: item.name,
                });
            });
        }
        return data;
    };

    const regionListModify = (arr: RegionBody[]) => {
        const data: ListFormattedType[] = [];
        if (arr.length) {
            arr.forEach((item: any) => {
                data.push({
                    label: `${item.region} (${item.region_name})`,
                    value: item.id,
                });
            });
        }
        return data;
    };

    const cloudNameListModify = (arr: Cred[]) => {
        const data: ListFormattedType[] = [];
        if (arr.length) {
            arr.forEach((item: any) => {
                data.push({
                    label: item.name,
                    value: item.id,
                });
            });
        }
        return data;
    };

    const getCredId = async (id: string) => {
        try {
            const response: any = await getCredIdData(id);
            // const response: any = await (
                // await axios.get(`http://localhost:3001/cloud/authorized/asdasdasdas`)
            // ).data;
            if (response && response.success) {
                setCredList(response.data);
            } else {
                setCredList([]);
            }
        } catch (error) {
            setCredList([]);
        }
    };

    const getInstancetypes = async (id: string) => {
        try {
            const response: any = await getInstanceTypesData(id);
            // const response: any = await (
                // await axios.get(`http://localhost:3001/cloud/instance-types/asdasdasdas`)
            // ).data;
            if (response && response.success) {
                setInstanceList(response.data);
            } else {
                setInstanceList([]);
            }
        } catch (error) {
            setInstanceList([]);
        }
    };

    // const getGcpProjectList = (clid: string) => {
    //   getGCPProjectListData(clid)
    //     .then((response) => {
    //       if (response && response.data && response.data.data) { setGcpProjectList(response.data.data); }
    //     })
    //     .catch(() => { setGcpProjectList([]); });
    // };

    useEffect(() => {
        //  Call api for Cred Ids
        getCredId(cid);
        // call api instanceTypes
        getInstancetypes(cid);
        // call api GCP list
        // getGcpProjectList(cid);
        // Call api for regions
        loadRegions(cid);
    }, []);

    const unsetHighlight = (x: string, flag: boolean) => {
        const b = document.getElementById(x);
        if (b) {
            if (flag) {
                if (b.classList.contains('formEmptyText')) {
                    b.classList.remove('formEmptyText');
                }
            } else {
                b.style.borderColor = '#ECEEF3';
            }
        }
    };
    const highlight = (x: string, flag: boolean) => {
        const b = document.getElementById(x);
        if (b) {
            if (flag) {
                if (!b.classList.contains('formEmptyText')) {
                    b.classList.add('formEmptyText');
                }
            } else {
                b.style.borderColor = 'red';
            }
        }
    };

    const instanceHandler = () => {
        const showArr = [];
        if (nodeCount) {
            for (let i = 0; i < nodeCount; i += 1) {
                showArr.push(instanceView(i));
            }
        }
        return showArr;
    };

    const instanceView = (idx: number) => (
        <div key={`instnameinpy${idx}`} className='mt-3'>
            <div className='row'>
                <div className='form mt-1 col-xl-5 col-lg-5 col-md-6 col-sm-12 cordaversion2'>
                    <h6>{`Node ${idx + 1}`}</h6>
                    <Inputbox
                        type='text'
                        className='form-control required'
                        id={`instname1${idx}`}
                        disabled
                        defaultValue={nodeNames[idx] ? nodeNames[idx] : ''}
                    />
                </div>
                <div className='form mt-1 col-xl-5 col-lg-5 col-md-6 col-sm-12 mx-auto cordaversion2'>
                    <h6>Select Instance Type</h6>
                    <Dropdown
                        defaultValue={cloudConfigDataZone.instanceArr ? cloudConfigDataZone.instanceArr[idx] : ''}
                        id='instance-type'
                        options={instanceTypeListModify(instancelist)}
                        onChange={(e) => {
                            handleInstance(idx, e.target.value);
                        }}
                        selectTitle='Select Instance Type'
                    />
                </div>
            </div>
        </div>
    );
    const checkInstance = () => {
        if (managedHosting) {
            return true;
        }

        const list = cloudConfigDataZone.instanceArr;
        if (!list) {
            highlight('instance-type', false);
            return false;
        }
        if (list.length !== nodeCount) {
            setCloudConfigDataZone({
                ...cloudConfigDataZone,
                instanceArr: instanceType,
            });
            highlight('instance-type', false);
            return false;
        }
        for (let i = 0; i < list.length; i += 1) {
            if (!list[i]) {
                highlight(`instname2${i}`, false);
                return false;
            }
        }
        return true;
    };
    const handleInstance = (n: number, val: string) => {
        const old = instanceType;
        old[n] = val;
        setInstanceType(old);
        setCloudConfigDataZone({
            ...cloudConfigDataZone,
            instanceArr: instanceType,
        });
        const errorTag = document.getElementById('error-tag');
        if (errorTag) {
            errorTag.style.display = 'none';
        }
        unsetHighlight('instance-type', false);
    };

    const handleCredInput = (credId: string) => {
        const credObj = credList.find((e) => e.id === credId);
        if (credObj && credObj.projects) {
            setGcpProjectList(credObj.projects);
        }
        unsetHighlight('z26', false);
        setshowNext({ ...showNext, s1: true });
        setCloudConfigDataZone({ ...cloudConfigDataZone, cloudAccount: credId });
    };

    const isCloudTypeGcp = () => {
        if (cloudId) {
            const cloudName = getCloudById(cloudId);
            // setCloudConfigDataZone({ ...cloudConfigDataZone, cloudName });
            return cloudName === 'GCP';
        }
        return false;
    };

    const solve = () => {
        if (
            (showNext.s1 || managedHosting || cloudConfigDataZone.cloudAccount) &&
            (showNext.s2 || cloudConfigDataZone.region) &&
            checkInstance() &&
            (managedHosting || !isCloudTypeGcp() || cloudConfigDataZone.gcpProjectId)
        ) {
            return submit();
        }
        if (!(showNext.s2 || cloudConfigDataZone.region)) {
            return highlight('z27', false);
        }
        if (!('cloudAccount' in cloudConfigDataZone && cloudConfigDataZone.cloudAccount !== '')) {
            return highlight('z26', false);
        }

        if (!(!managedHosting || !isCloudTypeGcp() || cloudConfigDataZone.gcpProjectId)) {
            return highlight('z28', false);
        }
        return highlight('z25', false);
    };

    return (
        <>
            <div className=' mt-3 col-11 mx-auto'>
                <div className='row'>
                    <div className='col-xl-8 col-lg-8 col-sm-12 mx-auto'>
                        <div className=' mt-5'>
                            <div className='row mt-3'>
                                <div className='form col-xl-5 col-lg-5 col-md-6 col-sm-12 cordaversion2'>
                                    <h6>Select Region</h6>
                                    <Dropdown
                                        id='z27'
                                        className='form-borderradius form-select'
                                        options={regionListModify(regions)}
                                        defaultValue={cloudConfigDataZone.region}
                                        onChange={(e) => {
                                            unsetHighlight('z27', false);
                                            setshowNext({ ...showNext, s1: true });
                                            setCloudConfigDataZone({
                                                ...cloudConfigDataZone,
                                                region: e.target.value,
                                            });
                                        }}
                                        selectTitle='Select Region'
                                    />
                                </div>
                                {!managedHosting && (
                                    <div className='form col-xl-5 col-lg-5 col-md-6 mx-auto col-sm-12 cordaversion2'>
                                        <h6>Select Cloud Account</h6>
                                        <Dropdown
                                            id='z26'
                                            options={cloudNameListModify(credList)}
                                            defaultValue={cloudConfigDataZone.cloudAccount}
                                            onChange={(e) => {
                                                handleCredInput(e.target.value);
                                            }}
                                            selectTitle='Select Account'
                                        />
                                    </div>
                                )}
                            </div>
                            <div className='row'>
                                {!managedHosting && instanceHandler()}
                                {!managedHosting && isCloudTypeGcp() && (
                                    <div className='form  col-xl-5 col-lg-5 col-md-6 col-sm-12 mt-3 cordaversion2'>
                                        <h6>Select GCP Project</h6>
                                        <select
                                            className='form-borderradius form-select'
                                            defaultValue={cloudConfigDataZone.gcpProjectId}
                                            id='z28'
                                            onChange={(e) => {
                                                unsetHighlight('z28', false);
                                                setshowNext({ ...showNext, s2: true });
                                                setCloudConfigDataZone({
                                                    ...cloudConfigDataZone,
                                                    gcpProjectId: e.target.value,
                                                });
                                            }}
                                        >
                                            <option>Select GCP Project</option>
                                            {gcpProjectList &&
                                                gcpProjectList.map((data, idx) => (
                                                    // eslint-disable-next-line react/no-array-index-key
                                                    <option
                                                        key={idx}
                                                        value={data.id}
                                                        selected={data.id === cloudConfigDataZone.gcpProjectId}
                                                    >
                                                        {data.name}
                                                    </option>
                                                ))}
                                        </select>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className='mt-5' style={{ textAlign: 'center' }}>
                        <div className='row text-center'>
                            <p id='error-tag' style={{ display: 'none', fontSize: 14, color: 'red' }}>
                                Error
                            </p>
                            <p id='errorTag2' style={{ display: 'none', fontSize: 14, color: 'red' }}>
                                Error
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            {/* <Footer last={last} submit={solve} showNext={isDisable} first={first} nextPage={nextPage} prev={prev} /> */}
            <Footer
                isLastPage={last}
                submit={solve}
                isFirstPage={first}
                nextPage={nextPage}
                prevPage={prev}
                submitText='Create'
            />
        </>
    );
};
export default CloudConfiguration;
